import { AxiosError, AxiosResponse } from 'axios';
import { UseMutationResult, UseMutationOptions, useMutation } from 'react-query';
import { useToastContext } from '@/contexts/toastContext';
import { onAPIError } from '@/utils/global';

const useApiSubmit = <ResponseType, ParamsType = void>(
  fn: (arg0?: any) => Promise<AxiosResponse<ResponseType>>,
  options?: UseMutationOptions<ResponseType, AxiosError, ParamsType>
): UseMutationResult<ResponseType, AxiosError, ParamsType> => {
  const toast = useToastContext();
  return useMutation(
    async (args) => {
      const { data } = await fn(args);
      return data;
    },
    {
      ...options,
      onError: (error) => onAPIError(error, options, toast),
    }
  );
};

export default useApiSubmit;
